import Vue from "vue"
import VueRouter from "vue-router"
import Project from "../components/Project.vue"
import Login from "../components/Login.vue"
import Register from "../components/Register.vue"

// 数字生态网站
import IndexMark from "../components/IndexMark.vue"
import IndexSystem from "../components/IndexSystem.vue"
import Channel from "../components/Content/Channel.vue"
import Template from "../components/Content/Template.vue"
import Attribute from "../components/Content/Attribute.vue"
import Content from "../components/Content/Content.vue"

import { getCookie } from "../common/utils"

Vue.use(VueRouter)

const routes = [
  { path: "/", redirect: "/project/IndexMark" },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  {
    path: "/project",
    component: Project,
    redirect: "project/IndexMark",
    children: [
      // 指数
      { path: "/project/IndexMark", component: IndexMark },
      { path: "/project/IndexSystem", component: IndexSystem },
      // 数字生态大会
      {
        path: "/project/meetingDesc",
        component: Content,
        props: {
          channel: "大会简介",
        },
      },
      {
        path: "/project/platformDesc",
        component: Content,
        props: {
          channel: "协同创新平台简介",
        },
      },
      {
        path: "/project/reportDown",
        component: Content,
        props: { channel: "报告下载" },
      },
      {
        path: "/project/partner",
        component: Content,
        props: { channel: "合作方" },
      },
      {
        path: "/project/thanks",
        component: Content,
        props: { channel: "特别鸣谢" },
      },
      {
        path: "/project/mediaReport",
        component: Content,
        props: { channel: "媒体报道" },
      },
      // 方法概述
      {
        path: "/project/summary",
        component: Content,
        props: { channel: "方法概述" },
      },
      // 实验室介绍
      {
        path: "/project/laboratory",
        component: Content,
        props: {
          channel: "实验室介绍",
        },
      },
      // 团队
      {
        path: "/project/expert",
        component: Content,
        props: { channel: "专家团队" },
      },
      {
        path: "/project/project",
        component: Content,
        props: { channel: "项目团队" },
      },
      // 新闻资讯
      {
        path: "/project/news",
        component: Content,
        props: { channel: "新闻资讯" },
      },
      // 专家检索
      {
        path: "/project/retrieval",
        component: Content,
        props: { channel: "专家检索" },
      },
      // 内容系统
      { path: "/project/Channel", component: Channel },
      { path: "/project/Template", component: Template },
      { path: "/project/Attribute", component: Attribute },
    ],
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.path.indexOf("login") === -1) {
    if (!getCookie("login") || JSON.parse(getCookie("login")) !== true) {
      next({
        path: "/login",
      })
    }
  }
  next()
})
export default router
